import React, { useEffect, useState, Fragment } from "react"

import { Popover, Transition, RadioGroup } from "@headlessui/react"
import { CheckCircleIcon, XIcon } from "@heroicons/react/solid"
import {
  Chat,
  Screen,
  PaintBrush,
  Bullhorn,
  Events,
  FaceDissatisfied,
  FaceNeutral,
  FaceSatisfied,
} from "@carbon/icons-react"
import { StaticImage } from "gatsby-plugin-image"
import LineBreak from "../assets/icons/lineBreak"
import { useForm } from "@formspree/react"
const services = [
  {
    name: "Needs work",
    icon: <FaceDissatisfied className="text-ec-sea h-6 w-6" />,
  },
  {
    name: "Does the job",
    icon: <FaceNeutral className="text-ec-sea h-6 w-6" />,
  },
  {
    name: "So beautiful!",
    icon: <FaceSatisfied className="text-ec-sea h-6 w-6" />,
  },
]

const BackToTopBtn = () => {
  const [showButton, setShowButton] = useState(false)
  const [service, setService] = useState(services[1])
  const [state, handleSubmit] = useForm("mjvzvgne")

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    })
  }, [])

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ")
  }

  if (state.succeeded) {
    return (
      <div>
        {showButton && (
          <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button
                  className={`
                  ${open ? "" : "text-opacity-90"}
                  inline-block rounded-full w-10 h-10 flex justify-center items-center bg-ec-sky text-white font-medium text-xs leading-tight uppercase shadow-md hover:bg-ec-sea hover:shadow-lg focus:bg-ec-sea focus:shadow-lg focus:outline-none focus:ring-0 active:bg-ec-sea active:shadow-lg transition ease-in-out bottom-20 right-5 fixed z-10`}
                >
                  <Bullhorn
                    className={`${open ? "" : "text-opacity-70"}
                    h-6 w-6`}
                    aria-hidden="true"
                  />
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="[z-index:100] fixed bottom-0 w-full md:right-8 md:bottom-40 z-10 mt-3 md:w-96 md:max-w-sm transform md:px-4 sm:px-0 lg:max-w-3xl">
                    <div className="overflow-hidden bg-ec-air shadow-lg lg:rounded-xl">
                      <div className="mx-auto   ">
                        <h4 className="py-4 mx-4 text-ec-sea font-heading text-xl pb-2 text-center">
                          Help Elemental Connection Grow
                        </h4>
                        <div className="flex justify-center px-12">
                          <LineBreak className="w-full h-full" />
                        </div>

                        <form onSubmit={handleSubmit} className="pt-6">
                          <RadioGroup
                            value={service}
                            onChange={setService}
                            className="my-2 px-4"
                          >
                            <RadioGroup.Label className="text-ec-sea text-sm">
                              Let us know what you think of our site and what
                              you would love to see in the future:
                            </RadioGroup.Label>
                            <div className="grid grid-cols-3 gap-1 mt-4">
                              {services.map((option) => (
                                <div className="flex flex-col" key={option.name}>
                                  <RadioGroup.Option
                                    key={option.name}
                                    value={option.name}
                                    name="feeling"
                                    className={({ active, checked }) =>
                                      classNames(
                                        option.icon
                                          ? "cursor-pointer focus:outline-none"
                                          : "opacity-25 cursor-not-allowed",
                                        active ? "ring-none" : "",
                                        checked
                                          ? " border-ec-earth  text-white"
                                          : "bg-ec-sky/20 border-gray-200 text-gray-900 hover:bg-gma-divide/20",
                                        "py-5 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1 transition border-2 rounded-lg"
                                      )
                                    }
                                  >
                                    <RadioGroup.Label as="span">
                                      {option.icon}
                                    </RadioGroup.Label>
                                  </RadioGroup.Option>
                                  <p className=" text-ec-sea text-sm py-1 text-center">
                                    {option.name}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </RadioGroup>
                          {/* <div className="px-4 pt-6 pb-2">
                            <label
                              htmlFor="comment"
                              className="block text-sm font-medium text-ec-sea"
                            >
                              Email:
                            </label>
                            <div className="mt-1">
                              <input
                                rows={4}
                                name="comment"
                                id="comment"
                                className="shadow-sm bg-white-inner border-b border-gma-text block w-full sm:text-sm focus:outline-none focus:border border-white text-ec-sea p-2 "
                                defaultValue={""}
                              />
                            </div>
                          </div> */}
                          <div className="px-4 py-6">
                            <label
                              htmlFor="comment"
                              className="block text-sm font-medium text-ec-sea"
                            >
                              How can we improve:
                            </label>
                            <div className="mt-1">
                              <textarea
                                rows={4}
                                name="comment"
                                id="comment"
                                placeholder="More crystals please!"
                                className="shadow-sm bg-ec-air border-2 border-ec-sea rounded-xl block w-full sm:text-sm focus:outline-none focus:ring-0 focus:border-2 focus:border-ec-sea text-ec-sea p-2 "
                                defaultValue={""}
                              />
                            </div>
                          </div>
                          <div className=" bg-ec-sea p-4 mb-2 mx-4 rounded-full">
                            <div className="flex">
                              <div className="flex-shrink-0">
                                <CheckCircleIcon
                                  className="h-5 w-5 text-white"
                                  aria-hidden="true"
                                />
                              </div>
                              <div className="ml-3">
                                <p className="text-sm font-medium text-white">
                                  Your submission was successful!
                                </p>
                              </div>
                              <div className="ml-auto pl-3">
                                <div className="-mx-1.5 -my-1.5">
                                  <button
                                    onClick={() =>
                                      window.location.reload(false)
                                    }
                                    type="button"
                                    className="inline-flex p-1.5 text-white rounded-full hover:bg-ec-sky/20 focus:outline-none"
                                  >
                                    <span className="sr-only">Dismiss</span>
                                    <XIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center justify-center gap-1">
                            <Popover.Button className="w-1/2 text-center text-white hover:bg-opacity-80 py-3 bg-ec-sea">
                              Cancel
                            </Popover.Button>
                            {state.submitting ? (
                              <button
                                type="submit"
                                disabled={state.submitting}
                                className="w-1/2 text-center items-center justify-center flex text-white hover:bg-opacity-80 py-3 bg-ec-sea"
                              >
                                <svg
                                  className="fill-white animate-spin mr-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                >
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path d="M18.364 5.636L16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364z" />
                                </svg>
                              </button>
                            ) : (
                              <button
                                type="submit"
                                disabled={state.submitting}
                                className="w-1/2 text-center text-white hover:bg-opacity-80 py-3 bg-ec-sea"
                              >
                                Submit
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
        )}
        {showButton && (
          <button
            type="button"
            data-mdb-ripple="true"
            data-mdb-ripple-color="light"
            className="inline-block rounded-full p-3 w-10 h-10 flex items-center bg-ec-sky text-white font-medium text-xs leading-tight uppercase shadow-md hover:bg-ec-sea hover:shadow-lg focus:bg-ec-sea focus:shadow-lg focus:outline-none focus:ring-0 active:bg-ec-sea active:shadow-lg transition ease-in-out bottom-5 right-5 fixed z-10"
            id="btn-back-to-top"
            aria-label="back to top"
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: "smooth", // for smoothly scrolling
              })
            }
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              className="w-4 h-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
              ></path>
            </svg>
          </button>
        )}
      </div>
    )
  }

  return (
    <div>
      {showButton && (
        <Popover className="relative">
          {({ open }) => (
            <>
              <Popover.Button
                className={`
                ${open ? "" : "text-opacity-90"}
                inline-block rounded-full w-10 h-10 flex items-center justify-center bg-ec-sky text-white font-medium text-xs leading-tight uppercase shadow-md hover:bg-ec-sea hover:shadow-lg focus:bg-ec-sea focus:shadow-lg focus:outline-none focus:ring-0 active:bg-ec-sea active:shadow-lg transition ease-in-out bottom-20 right-5 fixed z-10`}
              >
                <Bullhorn
                  className={`${open ? "" : "text-opacity-70"}
                  h-6 w-6`}
                  aria-hidden="true"
                />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="[z-index:100] fixed bottom-0 w-full md:right-8 md:bottom-40 z-10 mt-3 md:w-96 md:max-w-sm transform md:px-4 sm:px-0 lg:max-w-3xl">
                  <div className="overflow-hidden bg-ec-air shadow-lg lg:rounded-xl">
                    <div className="mx-auto   ">
                      <h4 className="py-4 mx-4 text-ec-sea font-heading text-xl pb-2 text-center">
                        Help Elemental Connection Grow
                      </h4>
                      <div className="flex justify-center px-12">
                        <LineBreak className="w-full h-full" />
                      </div>

                      <form onSubmit={handleSubmit} className="pt-6">
                        <RadioGroup
                          value={service}
                          onChange={setService}
                          className="my-2 px-4"
                          name="feeling"
                        >
                          <RadioGroup.Label className="text-ec-sea text-sm">
                            Let us know what you think of our site and what you
                            would love to see in the future:
                          </RadioGroup.Label>
                          <div className="grid grid-cols-3 gap-1 mt-4">
                            {services.map((option) => (
                              <div className="flex flex-col" key={option.name}>
                                <RadioGroup.Option
                                  key={option.name}
                                  value={option.name}
                                  name="feeling"
                                  className={({ active, checked }) =>
                                    classNames(
                                      option.icon
                                        ? "cursor-pointer focus:outline-none"
                                        : "opacity-25 cursor-not-allowed",
                                      active ? "ring-none" : "",
                                      checked
                                        ? " border-ec-earth  text-white"
                                        : "bg-ec-sky/20 border-gray-200 text-gray-900 hover:bg-gma-divide/20",
                                      "py-5 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1 transition border-2 rounded-lg"
                                    )
                                  }
                                >
                                  <RadioGroup.Label as="span">
                                    {option.icon}
                                  </RadioGroup.Label>
                                </RadioGroup.Option>
                                <p className=" text-ec-sea text-sm py-1 text-center">
                                  {option.name}
                                </p>
                              </div>
                            ))}
                          </div>
                        </RadioGroup>
                        {/* <div className="px-4 pt-6 pb-2">
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium text-ec-sea"
                          >
                            Email:
                          </label>
                          <div className="mt-1">
                            <input
                              rows={4}
                              name="comment"
                              id="comment"
                              className="shadow-sm bg-white-inner border-b border-gma-text block w-full sm:text-sm focus:outline-none focus:border border-white text-ec-sea p-2 "
                              defaultValue={""}
                            />
                          </div>
                        </div> */}
                        <div className="px-4 py-6">
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium text-ec-sea"
                          >
                            How can we improve:
                          </label>
                          <div className="mt-1">
                            <textarea
                              rows={4}
                              name="comment"
                              id="comment"
                              placeholder="More crystals please!"
                              className="shadow-sm bg-ec-air border-2 border-ec-sea rounded-xl block w-full sm:text-sm focus:outline-none focus:ring-0 focus:border-2 focus:border-ec-sea text-ec-sea p-2 "
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-center gap-1">
                          <Popover.Button className="w-1/2 text-center text-white hover:bg-opacity-80 py-3 bg-ec-sea">
                            Cancel
                          </Popover.Button>
                          {state.submitting ? (
                            <button
                              type="submit"
                              disabled={state.submitting}
                              className="w-1/2 text-center items-center justify-center flex text-white hover:bg-opacity-80 py-3 bg-ec-sea"
                            >
                              <svg
                                className="fill-white animate-spin mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                              >
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M18.364 5.636L16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364z" />
                              </svg>
                            </button>
                          ) : (
                            <button
                              type="submit"
                              disabled={state.submitting}
                              className="w-1/2 text-center text-white hover:bg-opacity-80 py-3 bg-ec-sea"
                            >
                              Submit
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      )}
      {showButton && (
        <button
          type="button"
          data-mdb-ripple="true"
          data-mdb-ripple-color="light"
          className="inline-block rounded-full p-3 w-10 h-10 flex items-center bg-ec-sky text-white font-medium text-xs leading-tight uppercase shadow-md hover:bg-ec-sea hover:shadow-lg focus:bg-ec-sea focus:shadow-lg focus:outline-none focus:ring-0 active:bg-ec-sea active:shadow-lg transition ease-in-out bottom-5 right-5 fixed z-10"
          id="btn-back-to-top"
          aria-label="back to top"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth", // for smoothly scrolling
            })
          }
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            className="w-4 h-4"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
            ></path>
          </svg>
        </button>
      )}
    </div>
  )
}

export default BackToTopBtn
